// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDz1NrAPIFYlFVxv-aE07vrYQyMO2DbzTc",
  authDomain: "sj-evento.firebaseapp.com",
  databaseURL: "https://sj-evento.firebaseio.com",
  projectId: "sj-evento",
  storageBucket: "sj-evento.appspot.com",
  messagingSenderId: "497591640725",
  appId: "1:497591640725:web:f3bd5f4476cbefff5d719c",
  measurementId: "G-592BEL5HS4"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/sj-evento.appspot.com/o/'